// CRM 2.0 registration appointment (M13-F4): Sub-Registrar booking from the portal.
// Backend: routes/crm2PortalAppointment.js. Used only for CRM 2.0 bookings (isCrm2).
import axios from "axios";

const apiUrl = `${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/portal/appointment`;

const unwrap = (promise) =>
	promise
		.then((res) => res.data?.data)
		.catch((err) => {
			throw new Error(err?.response?.data?.error || "Something went wrong. Please try again.");
		});

export const getCrm2Appointment = (apId) => unwrap(axios.get(`${apiUrl}/by-booking/${apId}`));

export const getCrm2Availability = (apId, officeId, from) =>
	unwrap(axios.get(`${apiUrl}/availability`, { params: { apId, officeId, ...(from ? { from } : {}) } }));

export const bookCrm2Appointment = (body) => unwrap(axios.post(`${apiUrl}/book`, body));
